'use client'

import { useEffect } from 'react'

import { useDispatch } from 'react-redux'

import type { Locale } from '@configs/i18n'
import { setLanguage } from '@/redux-store/slices/language'

const LanguageSync = ({ lang }: { lang: Locale }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setLanguage(lang))
  }, [lang, dispatch])

  return null
}

export default LanguageSync
